import { createSelector } from 'reselect';
import { breadcrumbSelector } from '../../workspace/breadcrumbs/breadcrumbSelector';
import { getElements } from '../utils/elementStoreUtils';
import { getElement } from '../../../common/elements/utils/elementTraversalUtils';
import { getPhysicalId } from '../../../common/elements/utils/elementPropertyUtils';
import { getIsBoardShared } from '../board/boardUtils';
import { ImMNElement } from '../../../common/elements/elementModelTypes';

type TagPath = ImMNElement[];

export const tagPathDisplaySelector = createSelector(breadcrumbSelector, getElements, (breadcrumbs, elements) => {
    const userRootPath: ImMNElement[] =
        breadcrumbs.path?.map((elementId) => {
            const element = getElement(elements, elementId);
            return getElement(elements, getPhysicalId(element));
        }) || [];

    let hasFoundSharedBoard = false;
    const shareRootPath: ImMNElement[] =
        userRootPath
            ?.reverse()
            .reduce((acc: TagPath, board: ImMNElement) => {
                if (hasFoundSharedBoard) return acc;

                if (getIsBoardShared(board)) hasFoundSharedBoard = true;

                acc.push(board);
                return acc;
            }, [])
            .reverse() || [];

    return { userRootPath, shareRootPath };
});
